import React from 'react'
import AnimatedCounter from './AnimatedCounter'
import { keyNumbers } from '../data/siteData'

const KeyNumbers = () => {
  return (
    <section className="section-padding bg-gradient-to-r from-primary-500 to-accent-500">
      <div className="container-custom">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Nos chiffres clés
          </h2>
          <p className="text-xl text-white opacity-90 max-w-2xl mx-auto">
            Des résultats concrets qui témoignent de notre engagement et de notre impact sur la région
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {keyNumbers.map((item, index) => (
            <div
              key={index}
              className="text-center"
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              <div className="bg-white bg-opacity-10 rounded-2xl p-8 backdrop-blur-sm hover:bg-opacity-20 transition-all duration-300">
                <div className="text-6xl mb-4">
                  {item.icon}
                </div>
                <div className="text-4xl md:text-5xl font-bold text-white mb-2">
                  <AnimatedCounter 
                    end={item.number} 
                    duration={2500}
                    suffix={item.number.includes('+') ? '+' : ''}
                  />
                </div>
                <p className="text-lg text-white opacity-90 font-medium">
                  {item.label}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Additional Stats */}
        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
          <div data-aos="fade-up" data-aos-delay="400">
            <div className="text-3xl font-bold text-white mb-2">
              <AnimatedCounter end="95" suffix="%" duration={3000} />
            </div>
            <p className="text-white opacity-90">Satisfaction clients</p>
          </div>
          <div data-aos="fade-up" data-aos-delay="500">
            <div className="text-3xl font-bold text-white mb-2">
              <AnimatedCounter end="12" duration={2000} />
            </div>
            <p className="text-white opacity-90">Régions desservies</p>
          </div>
          <div data-aos="fade-up" data-aos-delay="600">
            <div className="text-3xl font-bold text-white mb-2">
              <AnimatedCounter end="50" suffix="%" duration={2500} />
            </div>
            <p className="text-white opacity-90">Croissance annuelle</p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default KeyNumbers 